import React from "react";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { FileUpload } from "primereact/fileupload";
import { Calendar } from "primereact/calendar";
import { ProgressSpinner } from "primereact/progressspinner";
import config from "../../config";

// Component for editing a banner
const EditBannerForm = ({
  visible,
  onHide,
  editedBanner,
  syllabusOptions,
  mediumOptions,
  gradeOptions,
  onInputChange,
  handleDateChange,
  handleFileUpload,
  handleClearImage,
  fileUploadRef,
  filePreview,
  saveEditedBanner,
  loading,
}) => {
  const today = new Date();
  return (
    <Dialog
      header="Edit Banner"
      visible={visible}
      onHide={onHide}
      style={{ width: "700px", maxHeight: "700px" }}
    >
      <div className="p-fluid">
        <div style={{ display: "flex" }}>
          <div
            className="p-field"
            style={{ marginBottom: "20px", width: "50%" }}
          >
            <label htmlFor="syllabusId">Syllabus</label>
            <Dropdown
              id="syllabusId"
              name="syllabusId"
              value={editedBanner.syllabusId}
              options={syllabusOptions}
              onChange={onInputChange}
              optionLabel="label"
              optionValue="value"
              style={{ marginTop: "10px", marginRight: "20px" }}
            />
          </div>
          <div
            className="p-field"
            style={{ marginBottom: "20px", width: "50%" }}
          >
            <label htmlFor="mediumId">Medium</label>
            <Dropdown
              id="mediumId"
              name="mediumId"
              value={editedBanner.mediumId}
              options={mediumOptions}
              onChange={onInputChange}
              optionLabel="label"
              optionValue="value"
              style={{ marginTop: "10px" }}
            />
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div
            className="p-field"
            style={{ marginBottom: "20px", width: "50%" }}
          >
            <label htmlFor="gradeId">Grade</label>
            <Dropdown
              id="gradeId"
              name="gradeId"
              value={editedBanner.gradeId}
              options={gradeOptions}
              onChange={onInputChange}
              optionLabel="label"
              optionValue="value"
              style={{ marginTop: "10px", marginRight: "20px" }}
            />
          </div>
          <div
            className="p-field"
            style={{ marginBottom: "20px", width: "50%" }}
          >
            <label htmlFor="expireDate">Expire Date</label>
            <Calendar
              id="expireDate"
              name="expireDate"
              value={editedBanner.expireDate}
              onChange={handleDateChange}
              showIcon
              minDate={today}
              style={{ marginTop: "10px" }}
            />
          </div>
        </div>
        <div
          style={{ display: "flex", marginBottom: "40px", marginTop: "20px" }}
        >
          <div className="p-field" style={{ width: "50%" }}>
            <label htmlFor="type">Type</label>
            <br />
            <RadioButton
              id="type"
              name="type"
              value="banner"
              onChange={onInputChange}
              checked={editedBanner.type === "banner"}
              style={{ marginTop: "20px" }}
            />{" "}
            Banner &nbsp;
            <RadioButton
              id="type"
              name="type"
              value="advertisment"
              onChange={onInputChange}
              checked={editedBanner.type === "advertisment"}
              style={{ marginTop: "20px" }}
            />{" "}
            Advertisment
          </div>
          <div className="p-field" style={{ width: "50%" }}>
            <label htmlFor="visibility">Visibility</label>
            <br />
            <RadioButton
              id="visibility"
              name="visibility"
              value={true}
              onChange={onInputChange}
              checked={editedBanner.visibility === true}
              style={{ marginTop: "20px" }}
            />{" "}
            Yes &nbsp;
            <RadioButton
              id="visibility"
              name="visibility"
              value={false}
              onChange={onInputChange}
              checked={editedBanner.visibility === false}
              style={{ marginTop: "20px" }}
            />{" "}
            No
          </div>
        </div>
        <div className="p-field" style={{ marginBottom: "20px" }}>
          <label htmlFor="image">
            Image&nbsp;&nbsp;
            {editedBanner.type === "banner" && (
              <small style={{ color: "#808080", fontStyle: "italic" }}>
                (Square size, eg: 300 x 300)
              </small>
            )}
          </label>
          <FileUpload
            ref={fileUploadRef}
            name="image"
            accept="image/*"
            chooseLabel="Upload"
            uploadLabel="Upload"
            mode="basic"
            customUpload
            maxFileSize={1000000}
            onSelect={handleFileUpload}
            style={{ marginTop: "10px" }}
          />
          {filePreview && (
            <>
              <img
                src={filePreview}
                alt="Uploaded"
                style={{ maxWidth: "150px", marginTop: "10px" }}
              />
              <i
                className="pi pi-times-circle"
                onClick={handleClearImage}
                style={{
                  cursor: "pointer",
                  marginLeft: "10px",
                  verticalAlign: "middle",
                  fontSize: "1rem",
                  color: "#bb2124",
                }}
              ></i>
            </>
          )}
          {!filePreview && editedBanner.image && (
            <>
              <img
                src={`${config.apiUrl}/uploads/${editedBanner.image}`}
                alt="ExistingImage"
                style={{ maxWidth: "150px", marginTop: "10px" }}
              />
              <div
                style={{
                  maxWidth: "150px",
                  marginTop: "10px",
                  color: "#198754",
                }}
              >
                <b>
                  <center>{editedBanner.image}</center>
                </b>
              </div>
            </>
          )}
        </div>
      </div>
      <div
        className="p-dialog-footer"
        style={{
          marginTop: "30px",
          marginBottom: "-10px",
          marginRight: "-24px",
        }}
      >
        <Button label="Cancel" onClick={onHide} severity="danger" outlined />
        <Button
          label={
            loading ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                Saving...&nbsp;&nbsp;
                <ProgressSpinner
                  style={{
                    width: "20px",
                    height: "20px",
                    marginRight: "5px",
                  }}
                />
              </div>
            ) : (
              "Save"
            )
          }
          onClick={saveEditedBanner}
          severity="success"
          outlined
          disabled={loading}
        />
      </div>
    </Dialog>
  );
};

export default EditBannerForm;
